class AssetComment {
    constructor(id, message, owner, creationTime, modificationTime, annotationTime) {
        this.id = id;
        this.message = message;
        this.owner = owner;
        this.creationTime = creationTime;
        this.modificationTime = modificationTime;
        this.annotationTime = annotationTime;
    }
}

export { AssetComment };
